import { Component, EventEmitter, Inject, OnInit, OnDestroy, Output } from '@angular/core';
import { IonRadioGroupCustomEvent } from '@ionic/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Observable } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { BaseComponent, CoreFacade, CoreService, Language } from '@ridango/core';
import { OnboardingType } from '../../../enums';
import { ApplicationFacade } from '@ridango/components';
import Env from '@ridango/core/env';
import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';
import { DOCUMENT } from '@angular/common';
import { ScreenOrientationService } from '@ridango/core/lib/services/screenOrientation.service';

@Component({
    selector: 'rwidget-language-selection',
    templateUrl: './language-selection.component.html',
    styleUrls: ['./language-selection.component.scss']
})
export class LanguageSelectionComponent extends BaseComponent implements OnInit, OnDestroy {
    @Output() proceedNextView = new EventEmitter<string>();

    regionLanguages$: Observable<Language[]> = this.coreFacade.regionLanguages$;
    selectedLanguage$: Observable<Language> = this.coreFacade.selectedLanguage$;
    assetsPath$ = this.applicationFacade.assetsPath$;

    onboardingType = OnboardingType;
    continueButtonColor: string;
    regionLanguages = [];
    onlyPortraitMode$: Observable<boolean> = this.screenOrientationService.onlyPortraitMode$;

    constructor(
        @Inject('ENV') public env: Env,
        @Inject(DOCUMENT) private document: Document,
        private coreFacade: CoreFacade,
        private applicationFacade: ApplicationFacade,
        private coreService: CoreService,
        private localize: LocalizeRouterService,
        private screenOrientationService: ScreenOrientationService
    ) {
        super();
        this.setContinueButtonColor();
    }

    ngOnInit() {
        this.regionLanguages$.pipe(takeUntil(this.componentDestroyed$)).subscribe((regionLanguages) => {
            const lngOrder = this.env.ONBOARDING?.LANGUAGE_SELECTION_ORDER || [];
            const otherLanguages = regionLanguages
                .filter((l) => !lngOrder.includes(l.code))
                .sort((a, b) => (a.default_language === b.default_language ? 0 : a.default_language ? -1 : 1));

            this.regionLanguages = [
                ...lngOrder.map((code) => regionLanguages.find((l) => l.code === code)),
                ...otherLanguages
            ].filter(Boolean);
        });
    }

    setLanguage(event: IonRadioGroupCustomEvent<{ value: string }>): void {
        const selectedLangCode = event.detail.value;
        this.localize.changeLanguage(selectedLangCode);
        this.document.documentElement.lang = selectedLangCode;
        localStorage.setItem('LOCALIZE_DEFAULT_LANGUAGE', selectedLangCode);

        this.regionLanguages$.pipe(take(1)).subscribe((regionLanguages) => {
            this.coreService.setSelectedLanguage(regionLanguages.find((lang) => lang.code === selectedLangCode));
            this.applicationFacade.updateTermsUrl(selectedLangCode);
        });
    }

    setContinueButtonColor() {
        switch (this.env.THEME_NAME) {
            case ThemeFeature.GOTLAND_V2:
                this.continueButtonColor = 'primary';
                break;
            case ThemeFeature.SORMLAND_V2:
            case ThemeFeature.OREBRO:
            case ThemeFeature.VARMLAND:
                this.continueButtonColor = 'secondary';
                break;
            default:
                this.continueButtonColor = 'light';
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
